import React, { Component } from "react";
import { FiChevronLeft } from "react-icons/fi";
import { Redirect } from "react-router";
import Image from "../../../base/features/micro/Image";
import actionHandler from "../../../base/utils/action_handler";
import checkLength from "../../../base/utils/check_length";

class DynamicCategoryScroll extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="row mx-0 mb-4 px-0">
        {this.state.actionUrl && <Redirect push to={this.state.actionUrl} />}
        <div className="row mx-0 px-4 mb-3">
          <div
            style={{
              color: this.props.view.title_color,
              fontSize: this.props.view.title_size + "px",
            }}
            className={`col px-0 fw-bold`}
          >
            {this.props.view.title}
            <p
              style={{
                color: this.props.view.subtitle_color,
                fontSize: this.props.view.subtitle_size + "px",
              }}
              className={`col px-0 fw-bold mb-0 ${
                !this.props.view.subtitle_size && "fs-7"
              }`}
            >
              {this.props.view.subtitle}
            </p>
          </div>
          {this.props.view.action && (
            <div
              style={{
                color: this.props.view.action_color,
                fontSize: this.props.view.action_size + "px",
              }}
              className={`col-auto align-self-center px-0 fw-bold small ${
                !this.props.view.action_color && "color-main"
              }`}
              onClick={() =>
                this.setState({
                  actionUrl: actionHandler(
                    this.props.view.action,
                    this.props.view.action_data
                  ),
                })
              }
            >
              {this.props.view.action_title}
              <FiChevronLeft size="20" className="me-1" />
            </div>
          )}
        </div>
        <div
          className="px-4 scrollbar-hide"
          style={{
            overflow: "scroll hidden",
            whiteSpace: "nowrap",
          }}
        >
          {this.props.view.items?.map((item, i) => (
            <div
              className="d-inline-block p-0 text-center ms-3 align-top h-100"
              onClick={() =>
                item.action &&
                this.setState({
                  actionUrl: actionHandler(
                    item.action,
                    item.action_data,
                    item.title
                  ),
                })
              }
              style={{ width: "18%" }}
            >
              <div
                style={{
                  paddingTop:
                    (this.props.view.ratio.split(":")[1] /
                      this.props.view.ratio.split(":")[0]) *
                      100 +
                    "%",
                }}
                className="position-relative"
              >
                <Image
                  imageUri={item.media && item.media.thumbnail}
                  imgClassName="w-100 h-100 d-block img-cover rounded7 position-absolute top-0"
                  extraClassName="w-50 d-block rounded14 p-2 mx-auto bg-secondary"
                />
              </div>
              <p className="mb-0 mt-2 small fw-bold" dir="rtl">
                {item.title && checkLength(item.title, 20)}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default DynamicCategoryScroll;
